import { CommonModule } from '@angular/common';
import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, FormBuilder, FormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { getCountries, getCountryCallingCode } from 'libphonenumber-js';

@Component({
    selector: 'app-phone-input',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule],
    templateUrl: './phone-input.component.html',
    styleUrl: './phone-input.component.scss',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => PhoneInputComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => PhoneInputComponent),
            multi: true
        }
    ]
})
export class PhoneInputComponent implements OnInit, ControlValueAccessor {
    @Input() readonly: boolean = false;
    phoneForm!: FormGroup;
    countries: { isoCode: string; dialCode: string }[] = [];

    onChange = (value: string) => { };
    onTouched = () => { };

    constructor(private fb: FormBuilder) { }

    ngOnInit() {
        const allCountries = getCountries();
        this.countries = allCountries.map(code => ({
            isoCode: code,
            dialCode: '+' + getCountryCallingCode(code),
        }));
        this.countries.sort((a, b) => {
            if (a.dialCode === '+1') return -1;  // +1 (USA) en başa
            if (b.dialCode === '+1') return 1;
            return a.isoCode.localeCompare(b.isoCode); // diğerleri alfabetik
        });

        this.phoneForm = this.fb.group({
            country: ['TR'],
            dialCode: ['+90'],
            phoneNumber: ['']
        });

        this.phoneForm.valueChanges.subscribe(val => {
            const { dialCode, phoneNumber } = val;
            this.onChange(`${dialCode}${phoneNumber}`);
            this.onTouched();
        });

        this.phoneForm.get('country')!.valueChanges.subscribe(code => {
            const selected = this.countries.find(c => c.isoCode === code);
            this.phoneForm.patchValue({ dialCode: selected?.dialCode || '' }, { emitEvent: false });
        });

        // İlk değer emit
        const { dialCode, phoneNumber } = this.phoneForm.value;
        this.onChange(`${dialCode}${phoneNumber}`);
    }
    validate() {
        const dial = this.phoneForm.get('dialCode')?.value || '';
        const phone = this.phoneForm.get('phoneNumber')?.value || '';
        const value = dial + phone;

        // Eğer tamamen boşsa valid kabul et
        if (!dial && !phone) {
            return null;
        }
        if (!phone) {
            return null;
        }
        // regex kontrolü yap
        const isValid = /^\+\d{7,15}$/.test(value);
        return isValid ? null : { invalidPhone: true };
    }
    setDisabledState?(isDisabled: boolean): void {
        if (isDisabled) {
            this.phoneForm.disable({ emitEvent: false });
        } else {
            this.phoneForm.enable({ emitEvent: false });
        }
    }
    writeValue(value: string): void {
        if (value) {
          // En uzun eşleşen dial code'u bul
          const matchedDial = this.countries
            .map(c => c.dialCode)
            .sort((a, b) => b.length - a.length) // uzun olanlar önce
            .find(code => value.startsWith(code)) || '+90';
          const phone = value.replace(matchedDial, '');
      
          const matchedCountry = this.countries.find(c => c.dialCode === matchedDial)?.isoCode || 'TR';
      
          this.phoneForm.patchValue({
            country: matchedCountry,
            dialCode: matchedDial,
            phoneNumber: phone
          }, { emitEvent: false });
      
          this.onChange(`${matchedDial}${phone}`);
        }
      }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }
}
